import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH2Block,
  createH6Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getBackgroundImageOptions } from "../../../utils/backgroundHelpers";
import { getBackgroundColorOptions } from "../../../utils/buttonStyleHelpers";
import { getSalesBlockTertiaryStyleOptions } from "../constants";
import imagePreview from "./sales_block_10_image_placeholder_1.png";
import imagePlaceholder from "./sales_block_10_image_placeholder_2.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock10",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePreview,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "140px",
                height: "140px",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
          },
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "100% Satisfaction Guarantee",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createH6Block({
          text: "I'm so confident in the value of this program that I offer a 14-day satisfaction guarantee. If after our first two sessions you don't feel this is the right fit, I'll refund your investment in full—no questions asked.",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createPBlock({
          text: "This removes all risk from your decision and places the responsibility on me to deliver exceptional value. Your success is my highest priority.",
          paragraphStyle: "p3",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockTertiaryStyleOptions(),
        backgroundColor: getBackgroundColorOptions({
          defaultValue:
            "var(--theme-website-primary-button-hover-background-color)",
        }),
        backgroundImage: getBackgroundImageOptions({
          defaultValue: {
            signed_id: "",
            placeholder: imagePlaceholder,
          },
        }),
      },
    },
  },
};
